<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form ref="form" :model="model" style="height:100%;overflow:auto;" @keydown.native.enter.prevent="onSaveContinueBtnClick">
      <el-row :gutter="gutter">
        <el-col :span="8">
          <el-form-item label="站房名称" prop="name" :rules="[{
            required: true,
            message: '请输入站房名称'
          }]">
            <el-input v-model.trim="model.name" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="站房MN号" prop="mn" :rules="[{
            required: true,
            message: '请输入站房MN号'
          }]">
            <el-input v-model.trim="model.mn" maxlength="18" :readonly="model.id ? true : false"/>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="站房密码" prop="password" :rules="[{
            required: true,
            message: '请输入站房密码'
          }]">
            <el-input v-model.trim="model.password" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="8">
          <el-form-item label="站房类别" prop="categoryId">
            <el-select v-model="model.categoryId" style="width:100%">
              <el-option
                v-for="siteCategory in siteCategories"
                :key="siteCategory.id"
                :value="siteCategory.id"
                :label="siteCategory.name"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="采样高度(m)" prop="samplingHeight">
            <el-input v-model.trim="model.samplingHeight" type="number" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="启用日期" prop="enableDate" :rules="[{
            required: true,
            message: '请输入站房启用日期'
          }]">
            <el-date-picker
              v-model="model.enableDate"
              type="date"
              format="yyyy年MM月dd日"
              value-format="yyyy/MM/dd"
              :clearable="false"
              :editable="false"
              style="width:100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="6">
          <el-form-item label="站房经度" prop="longitude" :rules="[{
            required: true,
            message: '请输入站房经度'
          }]">
            <el-input v-model.trim="model.longitude" type="number" @change="onLngLatChanged" />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="站房纬度" prop="latitude" :rules="[{
            required: true,
            message: '请输入站房纬度'
          }]">
            <el-input v-model.trim="model.latitude" type="number" @change="onLngLatChanged" />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="省份" prop="province" :rules="[{
            required: true,
            message: '请输入省份'
          }]">
            <el-input v-model.trim="model.province" />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="城市 " prop="city" :rules="[{
            required: true,
            message: '请输入城市'
          }]">
            <el-input v-model.trim="model.city" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="isAdmin ? 12 : 20">
          <el-form-item label="站房地址" prop="address" :rules="[{
            required: true,
            message: '请输入站房地址'
          }]">
            <el-input v-model.trim="model.address" />
          </el-form-item>
        </el-col>

        <el-col v-if="isAdmin" :span="8">
          <el-form-item label="所属业主" prop="address">
            <el-select v-model="model.ownerOrgId" style="width:100%;">
              <el-option :value="null" label="请选择" />
              <el-option
                v-for="ownerOrg in ownerOrgs"
                :key="ownerOrg.id"
                :value="ownerOrg.id"
                :label="ownerOrg.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" style="padding-top:40px;">
          <el-form-item label="是否启用">
            <el-switch v-model="model.status" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <el-radio-group v-model="model.exportReport">
          <el-radio :label="1">出具报告</el-radio>
          <el-radio :label="0">不出具报告</el-radio>
        </el-radio-group>
      </el-form-item>

      <section class="display-map-layer">
        <a-map :features="['bg', 'road', 'point']" />
      </section>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <el-button v-if="operator === 1" type="orange" plain class="btn save-continue-btn" @click="onSaveContinueBtnClick">保存并继续</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'
import AMap from '../../../components/Map/index'
import GCJ02ToWGS84 from '../../../components/Map/GCJ02ToWGS84'

import * as MapEventKeyMap from '../../../components/Map/EventKeys'

export default {
  name: 'SiteEditor',
  extends: BaseEditor,
  components: {AMap},
  props: {
    ownerOrgs: {
      required: true,
      type: Array
    }
  },
  methods: {
    initModel () {
      let {siteCategories} = this

      return {
        id: null,
        name: '',
        mn: '',
        password: '',
        categoryId: Array.isArray(siteCategories) && siteCategories.length > 0 ? siteCategories[0].id : null,
        samplingHeight: null,
        enableDate: new Date().format('YYYY/MM/DD'),
        longitude: null,
        latitude: null,
        province: null,
        city: null,
        address: null,
        status: true
      }
    },
    afterGetDetail () {
      this.onLngLatChanged()
    },
    onLngLatChanged () {
      let {map} = this

      if (!map) {
        return
      }

      this.setGeoInfo(map)
    },
    setGeoInfo (map) {
      let {model} = this
      let {longitude, latitude} = model

      if (!longitude || !latitude) {
        return
      }

      this.changeLoadStatus(true)

      map.getGeoInfo(Number(longitude), Number(latitude)).then(result => {
        let {lngLat, geo: {regeocode: {addressComponent, formattedAddress}}} = result
        model.province = addressComponent.province
        model.city = addressComponent.city || addressComponent.district
        model.address = formattedAddress
        this.marker.setPosition(lngLat)
      }).catch(err => {
        this.$notify({
          title: '错误',
          message: err.message,
          type: 'error',
          position: 'bottom-right'
        })
      }).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onMapClick (event) {
      let {lnglat} = event
      let {model} = this
      lnglat = GCJ02ToWGS84(lnglat.lng, lnglat.lat)
      model.longitude = lnglat.lng
      model.latitude = lnglat.lat
      this.setGeoInfo(this.map)
    },
    onMapCreated (map) {
      this.map = map
      this.marker = map.createMarker({
        clickable: true,
        offset: map.createPixel(-12, -17)
      })
      this.setGeoInfo(map)
    }
  },
  created () {
    let {$eventBus} = this
    $eventBus.on(MapEventKeyMap.MAP_CREATED, this.onMapCreated)
    $eventBus.on(MapEventKeyMap.MAP_CLICK, this.onMapClick)
  },
  beforeDestroy () {
    let {$eventBus} = this
    $eventBus.off(MapEventKeyMap.MAP_CREATED, this.onMapCreated)
    $eventBus.off(MapEventKeyMap.MAP_CLICK, this.onMapClick)
  }
}
</script>

<style lang="scss" scoped>
.display-map-layer {
  position: relative;
  height: calc(100% - 408px);
  min-height: 310px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/SiteEditor.vue